"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeaderCell = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDraggable = _interopRequireDefault(require("react-draggable"));

var _reactSortableHoc = require("react-sortable-hoc");

var _reactVirtualized = require("react-virtualized");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseTranslation = require("nicbase-translation");

var _ColumnRenderer = require("./ColumnRenderer");

var _SortIndicator = _interopRequireDefault(require("./SortIndicator"));

var _excluded = ["column"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* Disable as the validation is a false positive. */

/* eslint react/prop-types: 0 */

/* eslint-disable jsx-a11y/no-static-element-interactions */
var HeaderCell = function HeaderCell(_ref) {
  var column = _ref.column,
      props = _objectWithoutProperties(_ref, _excluded);

  var headerColumnClassName = props.headerColumnClassName,
      headerStyle = props.headerStyle,
      onHeaderClick = props.onHeaderClick,
      sort = props.sort,
      sortBy = props.sortBy,
      sortDirection = props.sortDirection,
      onColumnResize = props.onColumnResize;
  var _column$props = column.props,
      dataKey = _column$props.dataKey,
      sortable = _column$props.sortable,
      label = _column$props.label,
      columnData = _column$props.columnData;
  var sortEnabled = sortable && sort;
  var a11yProps = {};

  if (onHeaderClick) {
    var onClick = function onClick() {
      onHeaderClick({
        columnData: columnData,
        dataKey: dataKey
      });
    };

    var onKeyDown = function onKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        onClick();
      }
    };

    a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
    a11yProps.role = 'rowheader';
    a11yProps.tabIndex = 0;
    a11yProps.onClick = onClick;
    a11yProps.onKeyDown = onKeyDown;
  }

  var style = (0, _ColumnRenderer.getFlexStyleForColumn)(column, headerStyle); // If this is a sortable header, clicking it should update the table data's sorting.

  var newSortDirection = sortBy !== dataKey || sortDirection === _reactVirtualized.SortDirection.DESC ? _reactVirtualized.SortDirection.ASC : _reactVirtualized.SortDirection.DESC;
  var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "ReactVirtualized__Table__headerTruncatedText",
      key: "label",
      title: typeof label === 'string' ? label : null
    }, label);
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, a11yProps, {
    className: headerColumnClassName,
    style: style
  }), /*#__PURE__*/_react["default"].createElement(DragHandle, null), sortEnabled ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "sort-indicator"
  }, /*#__PURE__*/_react["default"].createElement(_SortIndicator["default"], {
    active: sortBy === dataKey,
    sortDirection: sortDirection,
    onClick: function onClick() {
      return sort({
        sortBy: dataKey,
        sortDirection: newSortDirection
      });
    }
  })) : null, dataKey !== 'selection' ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "table.resizeColumn"
  }, function (title) {
    return /*#__PURE__*/_react["default"].createElement(_reactDraggable["default"], {
      axis: "x",
      zIndex: 999,
      enableUserSelectHack: false,
      position: {
        x: 0,
        y: 0
      },
      defaultClassName: "resizeHandle",
      defaultClassNameDragging: "resizeHandleDragging",
      onStop: function onStop(event, data) {
        return onColumnResize({
          dataKey: dataKey,
          deltaX: data.x
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      title: title,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }));
  }) : null);
};

exports.HeaderCell = HeaderCell;
HeaderCell.propTypes = {
  column: _propTypes["default"].element.isRequired,
  onColumnResize: _propTypes["default"].func,
  headerColumnClassName: _propTypes["default"].string,
  headerStyle: _propTypes["default"].shape({}),
  onHeaderClick: _propTypes["default"].func,
  sort: _propTypes["default"].func,
  sortBy: _propTypes["default"].string,
  sortDirection: _propTypes["default"].oneOf([_reactVirtualized.SortDirection.ASC, _reactVirtualized.SortDirection.DESC])
};

var noop = function noop() {};

HeaderCell.defaultProps = {
  onColumnResize: noop,
  headerStyle: {},
  headerColumnClassName: 'table-header-column',
  onHeaderClick: noop,
  sort: noop,
  sortBy: undefined,
  sortDirection: _reactVirtualized.SortDirection.ASC
};

var _default = new _reactSortableHoc.SortableElement(function (props) {
  return /*#__PURE__*/_react["default"].createElement(HeaderCell, props);
});

exports["default"] = _default;